import mixpanel from 'mixpanel-browser'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import LoadingAnimation from '../../components/LoadingAnimation/LoadingAnimation'
import { addLocaleToPath, getLocaleFromRouter } from '../../lib/addLocaleToPath'

const RestaurantHome = () => {
  const router = useRouter()
  let { query } = router
  const locale = getLocaleFromRouter(router.asPath)
  useEffect(() => {
    if (query.id) {
      mixpanel.init(`${process.env.NEXT_PUBLIC_MIXPANEL_USER}`, { debug: true, opt_out_tracking_by_default: false })
      mixpanel.track('Restaurant Landing', {
        source: 'with restaurant QR-Code',
      })
      router.push(addLocaleToPath(`/restaurant/${query.id}/menu`, locale))
    }
    if (query.orderType) {
      localStorage.setItem('orderType', query.orderType as string)
    }
    if (query.tableNumber) {
      localStorage.setItem('tableNumber', query.tableNumber as string)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])
  return (
    <div style={{ height: '100vh' }}>
      <LoadingAnimation />
    </div>
  )
}

export default RestaurantHome
